export default (date) => {
    var localDate = date ? new Date(date) : new Date();
    localDate.setHours(0);
    localDate.setMinutes(0);
    localDate.setSeconds(0);
    localDate.setMilliseconds(0);
    var userTimezoneOffset = localDate.getTimezoneOffset() * 60000;
    return new Date(localDate.getTime() - userTimezoneOffset);
};
